export enum EAuthorizationType {
  None = 0,
  Basic = 1,
  JWT = 2,
  Cookies = 5, 
}

export enum ETokenSource {
  LocalStorage = 1,
  DataBase = 2,
  Cookie = 3,
}

export enum ApihttpMethods {
  POST = 1,
  GET = 2,
  PUT = 3,
  DELETE = 4,
  PATCH = 5,
}

export enum ApiTypes {
  WebApi = 1,
  WCF = 2,
  ASMX = 3,
  Other = 4,
}

export enum EStatus {
  Unpublished = 1,
  Published = 2,
  Deleted = 3,
  Inactive = 4,
  Active = 5,
  All = 6,
}

export enum EApiReponseType {
  Array = 1,
  Object = 2,
  String = 3,
  Number = 4,
}

export enum EImportance {
  High = 1,
  Medium = 2,
  Low = 3,
}

export enum ERepeatType {
  None=0,
  OneTime = 3,
  Periodic = 4,
  Weekly = 5,
  Monthly = 6,
  InMonth = 7,
  Annual = 8,
}

export enum EventPlace {
  Inhouse = 1,
  External = 2,
}

export enum EPeriodType {
  Days = 1,
  Weeks = 2,
  Months = 3,
}
export enum ETemplateTypes {
  Page = 1,
  Blog = 2,
  Brand = 3,
  Category = 4,
  Product = 5,
}

export enum ESearchSortFields {
  Description = 1,
  ShortDesciption = 2,
  Specification = 3,
  Slug = 4,
  Name = 5,
  FromMin = 6,
  FromMax = 7,
  CreationDate = 8,
}

export enum ESortType {
  asc = 1,
  desc = 2,
}

/**
 * Where an input parameter of a data source takes its value from.
 * Mirrors SourceType in the API mapper backend.
 */
export enum ESourceType {
  Output = 0,
  Static = 1,
  RouterParameter = 2,
  LocalStorage = 3,
  SessionStorage = 4,
  User = 5,
  ResultData = 6,
  Control = 7,
  File = 8,
  ControlOrDefault = 9,
  TokenClaim = 10,
  /** The value comes from a field of the data source this one runs after. */
  DependOnOtherApi = 11,
}

/** Parameter direction, as the API mapper endpoints expect it. */
export enum EParameterDirection {
  Input = 1,
  Output = 2,
  InputOutput = 3,
  ReturnValue = 6,
}

/** Where a parameter is placed in the outgoing request. */
export enum EParamType {
  Header = 1,
  Body = 2,
  QueryString = 3,
  Path = 4,
  BodyArray = 5,
  FormFile = 6,
  FormData = 7,
}
